export class AnalyseViewNameChangeProgress {
  public readonly status = 'progress';
}

export class AnalyseViewNameChangeFailure {
  public readonly status = 'failure';
}

export class AnalyseViewNameChangeSuccess {
  public readonly status = 'success';
  constructor(public readonly name: string) {}
}

export type AnalyseViewNameChangeStatus = AnalyseViewNameChangeProgress | AnalyseViewNameChangeFailure | AnalyseViewNameChangeSuccess;
